import { render, staticRenderFns } from "./CmgBasicErrorModal.vue?vue&type=template&id=2fa514d0&scoped=true&lang=pug"
import script from "./cmg-basic-error-modal.ts?vue&type=script&lang=ts&external"
export * from "./cmg-basic-error-modal.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgBasicErrorModal.vue?vue&type=style&index=0&id=2fa514d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa514d0",
  null
  
)

export default component.exports